import { render, staticRenderFns } from "./ServiceProviderRow.vue?vue&type=template&id=e5c85900&scoped=true&lang=pug&"
import script from "./ServiceProviderRow.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderRow.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProviderRow.vue?vue&type=style&index=0&id=e5c85900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c85900",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VRow})
